import { render, staticRenderFns } from "./MailForwardView.vue?vue&type=template&id=30449b20"
import script from "./MailForwardView.vue?vue&type=script&lang=js"
export * from "./MailForwardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports